const LS_KEY = "isp_location_";
export default function getUserLocation(uuid) {
    let key = LS_KEY + uuid;
    if (key in localStorage) {
        return localStorage.getItem(key);
    }
    return null;
}
export function setUserLocation(value, uuid) {
    let key = LS_KEY + uuid;
    if (value) {
        localStorage.setItem(key, value);
    }
    else {
        localStorage.removeItem(key);
    }
}
//# sourceMappingURL=getUserLocation.js.map